import { motion } from 'framer-motion';

export const TheInsight = () => {
    return (
        <section className="relative py-32 md:py-40 px-6 md:px-24">
            <div className="max-w-2xl mx-auto">
                {/* Eyebrow */}
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1 }}
                    className="text-[10px] uppercase tracking-[0.4em] text-gray-600 font-mono mb-10"
                >
                    A simple observation
                </motion.p>

                {/* Body — each paragraph fades in staggered */}
                <div className="space-y-7">
                    <motion.p
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.1 }}
                        className="text-lg md:text-xl text-gray-300 font-light leading-relaxed"
                    >
                        Most intelligent systems are designed to sound certain.
                    </motion.p>

                    <motion.p
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.25 }}
                        className="text-base text-gray-500 font-light leading-relaxed"
                    >
                        That's understandable — certainty feels helpful. But it creates a quiet
                        problem: you can't tell when the system is guessing. A confident wrong
                        answer costs more than an honest <em className="text-gray-400 not-italic">"I'm not sure."</em>
                    </motion.p>

                    <motion.p
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.4 }}
                        className="text-base text-gray-500 font-light leading-relaxed"
                    >
                        We started wondering: what happens if you design systems that show
                        their uncertainty instead of hiding it? That track their own accuracy?
                        That remember what worked?
                    </motion.p>

                    <motion.p
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.55 }}
                        className="text-base text-gray-400 font-light leading-relaxed"
                    >
                        The answer surprised us. They don't just become more trustworthy — they
                        gain experience.{' '}
                        <span className="text-white font-normal">Honesty compounds.</span>
                    </motion.p>
                </div>

                {/* Subtle divider */}
                <motion.div
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.2, delay: 0.7 }}
                    className="h-[1px] bg-gradient-to-r from-transparent via-gray-800 to-transparent mt-20 origin-left"
                />
            </div>
        </section>
    );
};
